// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TI_17","select":"styles_select__lUk1f"};